import React from 'react';
import { useTranslation } from 'i18n';

export default function NotFound() {
  const { t } = useTranslation();

  return <>{t('Not Found')}</>;
}
